import { calculateQuoteVatSupportedTotals } from '@teinor/erp/prices/quote/totals'
interface calculateVatSupportedTotalsParams {
    rowPriceWithTax: number;
    vatMoney: number;
    vatMoney2?: number;
    retentionMoney?: number;
    rowPriceWithoutTax: number;
    total: number;
}
export const parseVatSupportedTableData = (tableData: calculateVatSupportedTotalsParams[]) => {
    const taxResult = calculateQuoteVatSupportedTotals(tableData)
    return taxResult
}